<ng-container *ngIf="part.component_type === 'MotorLabID'">
  <awc-form-select
    *ngIf="part.control_strategy_bpm !== null"
    label="Control Strategy"
    placeholder="Control Strategy..."
    [options]="controlStrategyBpms"
    [value]="[controlStrategyBpm + '' || '0']"
    (valueChange)="onControlStrategyChange('' + $event?.[0], 'control_strategy_bpm')"
    [size]="AWCFormElementSize.SMALL">
  </awc-form-select>
  <awc-form-select
    *ngIf="part.control_strategy_sync !== null"
    label="Control Strategy"
    placeholder="Control Strategy..."
    [options]="controlStrategySyncs"
    [value]="[controlStrategySync + '' || '0']"
    (valueChange)="onControlStrategyChange('' + $event?.[0], 'control_strategy_sync')"
    [size]="AWCFormElementSize.SMALL">
  </awc-form-select>
  <app-input
    label="Max Speed"
    placeholder="Optional..."
    [value]="part.max_speed"
    [type]="InputTypes.NUMBER"
    [unit]="UnitType.ANGULAR_SPEED"
    [id]="part.id+'_max_speed'"
    [updater]="update"
    [readOnly]="readonly"
    [disabled]="!forceEnable && (!fileResponse && !update)"
    (update)="setPart.emit([''+$event, 'max_speed', part.id+'_max_speed'])"></app-input>
  <app-input
    label="Stator Winding Temperature"
    placeholder="Optional..."
    [value]="part.stator_winding_temp"
    [type]="InputTypes.NUMBER"
    [unit]="UnitType.TEMPERATURE"
    [id]="part.id+'_stator_winding_temp'"
    [updater]="update"
    [readOnly]="readonly"
    [disabled]="!forceEnable && (!fileResponse && !update)"
    (update)="setPart.emit([''+$event, 'stator_winding_temp', part.id+'_stator_winding_temp'])"
  ></app-input>
  <app-input
    label="Rotor Temperature"
    placeholder="Optional..."
    [value]="part.rotor_temp"
    [type]="InputTypes.NUMBER"
    [unit]="UnitType.TEMPERATURE"
    [id]="part.id+'_rotor_temp'"
    [updater]="update"
    [readOnly]="readonly"
    [disabled]="!forceEnable && (!fileResponse && !update)"
    (update)="setPart.emit([''+$event, 'rotor_temp', part.id+'_rotor_temp'])"
  ></app-input>
  <app-input
    label="Stator Current Limit (Peak)"
    placeholder="Optional..."
    [value]="part.stator_current_limit"
    [type]="InputTypes.NUMBER"
    [unit]="UnitType.CURRENT"
    [id]="part.id+'_stator_current_limit'"
    [updater]="update"
    [readOnly]="readonly"
    [disabled]="!forceEnable && (!fileResponse && !update)"
    (update)="setPart.emit([''+$event, 'stator_current_limit', part.id+'_stator_current_limit'])"></app-input>
</ng-container>
<ng-container *ngIf="part.component_type === 'MotorLossMapID'">
  <app-input
    label="Poles"
    placeholder="Optional..."
    [value]="part.poles"
    [type]="InputTypes.NUMBER"
    [id]="part.id+'_poles'"
    [updater]="update"
    [readOnly]="readonly"
    (update)="setPart.emit([''+$event, 'poles', part.id+'_poles'])"
  ></app-input>
</ng-container>
<div class="two-col-inputs">
  <app-input
    label="Cost"
    placeholder="Optional..."
    [value]="part.cost"
    [type]="InputTypes.NUMBER"
    [id]="part.id+'_cost'"
    [updater]="update"
    [readOnly]="readonly"
    (update)="setPart.emit([''+$event, 'cost', part.id+'_cost'])"></app-input>
  <app-input
    label="Mass"
    placeholder="Optional..."
    [value]="part.mass"
    [unit]="UnitType.MASS"
    [type]="InputTypes.NUMBER"
    [id]="part.id+'_mass'"
    [updater]="update"
    [readOnly]="readonly"
    (update)="setPart.emit([''+$event, 'mass', part.id+'_mass'])"></app-input>
</div>
<div *featureFlag="featureFlagsEnum.FEATURE_INERTIA_INPUTS">
  <app-input
    label="Moment of Inertia"
    placeholder="Optional..."
    [value]="part.moment_of_inertia"
    [type]="InputTypes.NUMBER"
    [unit]="UnitType.INERTIA"
    [id]="part.id+'_moment_of_inertia'"
    [updater]="update"
    [readOnly]="readonly"
    (update)="setPart.emit([''+$event, 'moment_of_inertia', part.id+'_moment_of_inertia'])"
  ></app-input>
</div>

@if (part.component_type === 'MotorLabID') {
  <ng-container *featureFlag="FeatureFlagsEnum.FEATURE_THERMAL_MODEL">
    <awc-accordion [label]="'Thermal Model Details'">
      <div class=" two-col-inputs">
      @if (part.thermal_model_details?.model_type === 'None' || !update) {
        <awc-input
          class="two-col-span"
          [value]="thermalFile?.name || ''"
          [label]="'Thermal Model'"
          [iconButton]="{ icon: Icons.ADD_GEOMETRY }"
          [placeholder]="'Select thermal model file'"
          [readOnly]="true"
          (valueChange)="title = $event.toString()"
          (iconButtonAction)="onUploadClicked()"
          [size]="InputSize.SMALL"
        ></awc-input>
        <input #fileUpload hidden type="file" accept=".therm" (change)="onFileSelected($event)" [cyData]="'thermal-model-file-upload-input'">
      } @else {
        <app-input
          class="two-col-span"
          [label]="'Thermal Model Type'"
          [value]="part.thermal_model_details?.model_type === 'OneDimension' ? 'Variable Speed' : part.thermal_model_details?.model_type === 'TwoDimension' ? 'Variable Speed and Flow Rate' : 'None'"
          [type]="InputTypes.TEXT"
          [readOnly]="true"
        ></app-input>
      }

      @if (['OneDimension', 'TwoDimension'].includes(part.thermal_model_details?.model_type) && part.thermal_model_details?.speeds) {
        <app-input
          label="Stator Winding Temperature Limit"
          placeholder="Optional..."
          class="two-col-span"
          [value]="part.thermal_limits?.stator"
          [type]="InputTypes.NUMBER"
          [unit]="UnitType.TEMPERATURE"
          [id]="part.id+'_thermal_limits.stator'"
          [updater]="update"
          [readOnly]="readonly"
          [disabled]="!forceEnable && (!fileResponse && !update)"
          (update)="setPart.emit([''+$event, 'thermal_limits.stator', part.id+'_thermal_limits.stator'])"
        ></app-input>
        <awc-select
          label="Stator Limit Type"
          class="two-col-span"
          [items]="statorLimitTypes"
          [selectedItems]="[part.thermal_limits?.stator_limit_type + '']"
          [clearAllButton]="false"
          (selectionChanged)="onStatorLimitTypeChange($event[0].id, 'thermal_limits.stator_limit_type')"
        ></awc-select>
        <app-input
          label="Rotor Temperature Limit"
          placeholder="Optional..."
          class="two-col-span"
          [value]="part.thermal_limits?.rotor"
          [type]="InputTypes.NUMBER"
          [unit]="UnitType.TEMPERATURE"
          [id]="part.id+'_thermal_limits.rotor'"
          [updater]="update"
          [readOnly]="readonly"
          [disabled]="!forceEnable && (!fileResponse && !update)"
          (update)="setPart.emit([''+$event, 'thermal_limits.rotor', part.id+'_thermal_limits.rotor'])"
        ></app-input>
        @if (['TwoDimension'].includes(part.thermal_model_details?.model_type)) {
        <app-input
          [label]="'Flow Rate'"
          [placeholder]="'Flow Rate...'"
          class="two-col-span"
          [value]="part.flow_rate"
          [type]="InputTypes.NUMBER"
          [unit]="UnitType.VOLUMETRIC_FLOW_RATE"
          [id]="part.id + '_flow_rate'"
          [updater]="update"
          [readOnly]="readonly"
          (update)="setPart.emit(['' + $event, 'flow_rate', part.id + '_flow_rate'])"
        ></app-input>
          <app-input
            [label]="'Min Flow Rate'"
            [placeholder]="'Min Flow Rate...'"
            [value]="minFlowRate"
            [type]="InputTypes.NUMBER"
            [unit]="UnitType.VOLUMETRIC_FLOW_RATE"
            [readOnly]="true"
          ></app-input>
          <app-input
            [label]="'Max Flow Rate'"
            [placeholder]="'Max Flow Rate...'"
            [value]="maxFlowRate"
            [type]="InputTypes.NUMBER"
            [unit]="UnitType.VOLUMETRIC_FLOW_RATE"
            [readOnly]="true"
          ></app-input>
        <app-input
          [label]="'Number of Flow Rates'"
          [placeholder]="'Number of Flow Rate...'"
          [value]="part.thermal_model_details?.flow_rates.length || ''"
          [type]="InputTypes.NUMBER"
          [readOnly]="true"
          class="two-col-span"
        ></app-input>
      }
        <app-input
          [label]="'Min Speed'"
          [placeholder]="'Min Speed...'"
          [value]="minSpeed"
          [type]="InputTypes.NUMBER"
          [unit]="UnitType.ANGULAR_SPEED"
          [readOnly]="true"
        ></app-input>
        <app-input
          [label]="'Max Speed'"
          [placeholder]="'Max Speed...'"
          [value]="maxSpeed"
          [type]="InputTypes.NUMBER"
          [unit]="UnitType.ANGULAR_SPEED"
          [readOnly]="true"
        ></app-input>
        <app-input
          [label]="'Number of Speeds'"
          class="two-col-span"
          [placeholder]="'Number of Speeds...'"
          [value]="part.thermal_model_details?.speeds?.length || ''"
          [type]="InputTypes.NUMBER"
          [readOnly]="true"
        ></app-input>
      }
      </div>
    </awc-accordion>
  </ng-container>
}
